var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 283.9 283.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 0h-97a18 18 0 0 0 0 35h55l-92 92a17 17 0 0 0 0 25 17 17 0 0 0 25 0l92-92v55a18 18 0 0 0 35 0V18c0-10-8-18-18-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201 254H30V83h129l30-30H15C7 53 0 60 0 68v201c0 8 7 15 15 15h201c8 0 15-7 15-15V95l-30 30v129z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.9cb78e4135994f191b400a3cf236a326.svg";
export { ForwardRef as ReactComponent };